import { useState } from 'react';

import cmsHelpers from 'src/utils/cmsHelper';

export default function Index() {
  const [cmsEntries, setCmsEntries] = useState([]);
  const [cmsData, setCmsData] = useState({});
  const [cmsAssets, setCmsAssets] = useState([]);
  const [cmsNavigations, setCmsNavigations] = useState([]);

  async function fetchData(data: any) {
    const assets = data?.includes?.Asset || [];
    const entries = data?.includes?.Entry || [];
    const dataFormatted = cmsHelpers.formatCMSRawData(data);
    const navigations = dataFormatted.navigation || [];

    setCmsEntries(entries);
    setCmsAssets(assets);
    setCmsData(dataFormatted);
    setCmsNavigations(navigations);
  }

  return { cmsEntries, cmsData, cmsAssets, cmsNavigations, fetchData };
}
